module.exports = __webpack_public_path__ + "static/media/20ECE23.4a6a23bd.jpg";